import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axiosInstance from '../../AxiosInstance';

const UserDialog = ({ open, onClose, onSubmitSuccess, fetchUsers }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post('/users/register', {
        name: data.name,
        email: data.email,
        phoneNumber: data.phoneNumber,
      });

      onSubmitSuccess(response.data);
      reset();
      onClose();
      fetchUsers();
    } catch (error) {
      console.error('Error registering user:', error);
      alert(`Registration failed: ${error.response?.data?.message || error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold mb-6 text-gray-900 dark:text-white">Register New User</h2>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            {/* Name Field */}
            <div>
              <label htmlFor="name" className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-1">
                Name*
              </label>
              <input
                id="name"
                type="text"
                {...register('name', { required: 'Name is required' })}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white"
                placeholder="Enter name"
              />
              {errors.name && <p className="mt-1 text-red-500 text-xs">{errors.name.message}</p>}
            </div>

            {/* Phone Number Field */}
            <div>
              <label htmlFor="phoneNumber" className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-1">
                Phone Number*
              </label>
              <input
                id="phoneNumber"
                type="text"
                {...register('phoneNumber', { required: 'Phone number is required' })}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white"
                placeholder="Enter phone number"
              />
              {errors.phoneNumber && <p className="mt-1 text-red-500 text-xs">{errors.phoneNumber.message}</p>}
            </div>

            {/* Email Field */}
            <div>
              <label htmlFor="email" className="block text-gray-700 dark:text-gray-300 text-sm font-medium mb-1">
                Email*
              </label>
              <input
                id="email"
                type="email"
                {...register('email', { required: 'Email is required' })}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white"
                placeholder="Enter email"
              />
              {errors.email && <p className="mt-1 text-red-500 text-xs">{errors.email.message}</p>}
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3 pt-4">
              <button
                type="button"
                onClick={() => {
                  reset();
                  onClose();
                }}
                className="px-4 py-2 text-gray-700 bg-gray-100 dark:bg-gray-700 dark:text-white rounded-md hover:bg-gray-200"
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-400"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Registering...' : 'Register'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserDialog;
